import momentJalaali from "moment-jalali";
import { Button, Card, Row } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { setDialog } from "../store/api/GetAllProduct";
import { EyeFill, EyeSlashFill, Search } from "react-bootstrap-icons";
import { searchProductRequest, deleteProductRequest, getProductRequestStatusList } from "../store/api/ProductRequest";
import DatePicker from "react-datepicker2";
import { useForm } from "react-hook-form";
import BihamtaTable from "../../Components/BihamtaTable";
import { isMobileApp } from "../../store/api/CommonFunctions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBroom } from "@fortawesome/free-solid-svg-icons";
const SearchProductRequest = () => {
    const frmFilters = useRef();
    const [showFilter, setShowFilter] = useState(true);
    const filterData = useSelector(state => state.ProductRequestReducer.productRequestFilters);
    const statusList = useSelector(state => state.ProductRequestReducer.requestStatusList);
    const [dateFilters, setDateFilters] = useState({                
        CreationDate: filterData.CreationDate,
        CreationDateTo: filterData.CreationDateTo,
        RequestDate: filterData.RequestDate,
        RequestDateTo: filterData.RequestDateTo});
    const { register, handleSubmit } = useForm();
    const dispatch = useDispatch();
    function clearFilters()
    {
        frmFilters.current.reset();
        setDateFilters(
        {              
            CreationDate: null,
            CreationDateTo: null,
            RequestDate: null,
            RequestDateTo: null});
            dispatch(searchProductRequest({Take:10, Skip:0}));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        if (filterData?.CreationDate || filterData?.CreationDateTo || filterData?.RequestDate || filterData?.RequestDateTo) {
            setDateFilters({
                CreationDate: filterData.CreationDate,
                CreationDateTo: filterData.CreationDateTo,
                RequestDate: filterData.RequestDate,
                RequestDateTo: filterData.RequestDateTo
            })
        }
        dispatch(getProductRequestStatusList());
    }, []);
    const search = (data) => {
        data.Skip = 0;
        data.Take = 10;
        if (document.getElementsByName("creationDate")[0].value !== "") {
            data.CreationDate = dateFilters.CreationDate;
        }
        if (document.getElementsByName("creationDateTo")[0].value !== "") {
            data.CreationDateTo = dateFilters.CreationDateTo;
        }
        if (document.getElementsByName("requestDate")[0].value !== "") {
            data.RequestDate = dateFilters.RequestDate;
        }
        if (document.getElementsByName("requestDateTo")[0].value !== "") {
            data.RequestDateTo = dateFilters.RequestDateTo;
        }
        dispatch(searchProductRequest(data));
    }
    const history = useHistory();
    const showRequest = (id) => {
        history.push("/Services/PartRequest/" + id);
    }
    const showRelated = (req) => {
        if (!req.ServiceID || req.ServiceID === '') {
            return;
        }
        history.push(`/Services/Service/${req.ServiceID}/${req.ServiceType}`, null);
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    const onDeleteSuccess = (id) => {
        // const removedList = requestList.SearchResult.slice();
        // requestList.SearchResult = removedList.filter(r => r.RequestID !== id);
        // setCount(requestList.length - 1);
        search();
    }
    const tableColes = [
        { colTitle: "نام مشتری", colName: "CustomerName", showInMobile: true },
        { colTitle: "آدرس", colName: "RequestAddress", showInMobile: true, colType: "string", maxLength: 150 },
        { colTitle: "وضعیت", colName: "StatusName", showInMobile: true },
        { colTitle: "شماره درخواست", colName: "RequestNo", showInMobile: false },
        { colTitle: "تاریخ درخواست", colName: "PRequestDate", showInMobile: false },
        { colTitle: "نام کالا", colName: "ProductName", showInMobile: false },
        { colTitle: "شماره سریال", colName: "ProductSerial", showInMobile: false, style:{fontFamily:"Dark-Sans", fontSize:"11.5px"} },
        { colTitle: "نوع سرویس", colName: "PServiceType", showInMobile: false },
        { colTitle: "شماره سرویس", colName: "ServiceNumber", showInMobile: false }
    ]
    const tableRowButtons = [
        {
            title: "حذف درخواست", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف درخواست',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteProductRequest(item.RequestID, () => onDeleteSuccess(item.RequestID))
                }))
            }
        },
        {
            title: "نمایش درخواست", type: "show", className: "group-Btn-smalll btn-success", onclick: (item) => showRequest(item.RequestID), showCondition: isMobileApp
        },
        {
            title: "سرویس مرتبط", type: "related", className: "group-Btn-smalll btn-secondary", showCondition: (item) => item.ServiceType !== null && item.ServiceID !== null,
            onclick: (item) => { showRelated(item) }
        }

    ]
    return (<div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
        <br />
        <Card>
            <Card.Header className="headerStyle">جستجوی درخواست</Card.Header>
            <Card.Body className="bodyStyle">
                <form onSubmit={handleSubmit(search)} ref={frmFilters}>
                    <Row id="divFilters" className="rowBorder" >
                        <div className="rowTitle">
                            فیلترهای جستجو
                            &nbsp;
                            {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                            {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                            {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                        </div>
                        <div className="form-group col-md-3">
                            <DatePicker placeholder='تاریخ درخواست از' isGregorian={false} timePicker={false} className="form-control" name="requestDate"
                                onChange={value => setDateFilters({ ...dateFilters, RequestDate: value.local("en").format("YYYY-MM-DD") })}
                                value={dateFilters?.RequestDate ? momentJalaali(dateFilters.RequestDate) : null} />
                        </div>
                        <div className="form-group col-md-3">
                            <DatePicker placeholder='تاریخ درخواست تا' isGregorian={false} timePicker={false} className="form-control" name="requestDateTo"
                                onChange={value => setDateFilters({ ...dateFilters, RequestDateTo: value.local("en").format("YYYY-MM-DD") })}
                                value={dateFilters?.RequestDateTo ? momentJalaali(dateFilters.RequestDateTo) : null} />
                        </div>

                        <div className="form-group col-md-3">
                            <DatePicker placeholder='تاریخ ایجاد از' isGregorian={false} timePicker={false} className="form-control" name="creationDate"
                                value={dateFilters?.CreationDate ? momentJalaali(dateFilters.CreationDate):null }
                                onChange={value => setDateFilters({ ...dateFilters, CreationDate: value.local("en").format("YYYY-MM-DD") })} />
                        </div>
                        <div className="form-group col-md-3">
                            <DatePicker placeholder='تاریخ ایجاد تا' isGregorian={false} timePicker={false} className="form-control" name="creationDateTo"
                                value={dateFilters?.CreationDateTo ? momentJalaali(dateFilters.CreationDateTo) : null}
                                onChange={value => setDateFilters({ ...dateFilters, CreationDateTo: value.local("en").format("YYYY-MM-DD") })} />
                        </div>
                        <div className="form-group col-md-3" style={{ textAlign: "right" }}>
                            {statusList === "PENDING" &&
                                <div className='form-control col-md-3'>
                                    <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                                    <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری لیست وضعیت</span>
                                </div>
                            }
                            {statusList &&  Array.isArray(statusList) &&
                                <select className="form-control" name="StatusId" ref={register({})} defaultValue={filterData?.StatusId ?? ""}>
                                    <option value="">وضعیت را انتخاب کنید</option>
                                    {
                                        statusList.map((item, i) => { return (<option key={i} code={item.Code} value={item.ID}>{item.StatusName}</option>) })
                                    }
                                </select>
                            }
                        </div>
                    </Row>
                    <div>
                        <Button type="submit" className="mt-2 group-Btn-large"><Search size={15} />&nbsp;جستجوی درخواست </Button>
                    </div>
                </form>

                <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData} rowClick={(row) => showRequest(row.RequestID)}
                    searchMethod={(data) => dispatch(searchProductRequest(data))} reducerName="ProductRequestReducer" objectName="productRequestList" hasPaging={true} />
            </Card.Body>

        </Card>
    </div>
    );
}
export default SearchProductRequest;